export enum PreviewEmailTypeEnum {
	DEFAULT = 'default',
	CUSTOM = 'custom',
}
